export function StopIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg className={className} width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.5" y="3" width="3" height="10" rx="0.833333" fill="currentColor" />
      <rect x="7.5" y="3" width="3" height="10" rx="0.833333" fill="currentColor" />
    </svg>
  );
}

StopIcon.displayName = 'StopIcon';
